import { RemoteConfigProperties, ViewId } from "@madhive/mad-sdk";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { getUserPermissions } from "components/Auth/utils";
import { shallowEqual, useSelector } from "react-redux";
import {
  selectCurrentUser,
  selectProductionViews
} from "appReducers/authReducer";

export function useManagePricesView(): boolean {
  const user = useSelector(selectCurrentUser, shallowEqual);
  const isVerticalBillingEnabled: boolean = useFeatureFlag(
    RemoteConfigProperties.VERTICAL_BILLING
  );

  const orgProductionViews = useSelector(selectProductionViews);
  const { canView: canViewManagePrices } = getUserPermissions(
    ViewId.MANAGE_PRICES,
    user?.abilities ?? []
  );

  const filteredViews =
    /* @ts-expect-error - (TS Upgrade: 5.7.3) - https://typescript.tv/errors/#ts7053 */
    user?.viewIds.filter(view => orgProductionViews[view]) ?? [];

  const orgHasManagePrices = filteredViews.some(
    view => view === ViewId.MANAGE_PRICES
  );

  if (!isVerticalBillingEnabled) {
    return false;
  }

  // Dev users still need the ability check - they can configure all views
  // in UserPermissionsForm, but sidebar respects actual abilities
  return orgHasManagePrices && canViewManagePrices;
}
